// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XCQZj{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.GJn1G{background-color:#f8fafc}
.Fu12H{--bs-gutter-x: 0;width:100%;max-width:100%;padding:0;margin:0;background-color:#f8fafc}
.Fu12H>.row{--bs-gutter-x: 0;margin-left:0;margin-right:0}
.Fu12H>.row > [class*="col"]{padding-left:0;padding-right:0}
.fUniE{width:100%;padding:0 24px 32px;-webkit-box-sizing:border-box;box-sizing:border-box}
.W_nr3{background-color:#fff;border-radius:12px 12px 0 0;max-width:1200px;margin:0 auto;width:100%}
.Yu8AM{background-color:#fff;border-radius:12px;max-width:1200px;margin:0 auto;width:100%}
.pPENV{background-color:#fff;border-radius:0 0 12px 12px;max-width:1200px;margin:0 auto;width:100%}
.KJ8or{-webkit-animation:BIepg .4s ease-out forwards;animation:BIepg .4s ease-out forwards;opacity:0}
@-webkit-keyframes BIepg{from{opacity:0;-webkit-transform:translateY(8px);transform:translateY(8px)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}
@keyframes BIepg{from{opacity:0;-webkit-transform:translateY(8px);transform:translateY(8px)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}
@-webkit-keyframes YsQjh{from{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-8px);transform:translateY(-8px)}}
@keyframes YsQjh{from{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-8px);transform:translateY(-8px)}}
.IJ8lS{color:#64748b;font-size:12px;font-size:.75rem;font-weight:400;line-height:1.4;margin-top:8px;margin-top:.5rem;margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `XCQZj`,
	"wizardContainer": `GJn1G`,
	"fullScreenContainer": `Fu12H`,
	"wizardShell": `fUniE`,
	"wizardStepPanel": `W_nr3`,
	"wizardStepPanelStandalone": `Yu8AM`,
	"wizardStepFooterPanel": `pPENV`,
	"fadeIn": `KJ8or`,
	"fadeInTransition": `BIepg`,
	"helperText": `IJ8lS`,
	"fadeOutTransition": `YsQjh`
};
module.exports = ___CSS_LOADER_EXPORT___;
